module.exports = __webpack_public_path__ + "static/media/Ankita Shah.e30fd4f6.jpeg";